import { Services } from "./utils/ApiHelper";
import { toast } from "react-toastify";
import { getSession, getUser, setSession, setUser } from "./utils/StorageUtils";
import { cryptoUtil } from "./utils/CryptoUtil";
import Builders from "./utils/Builders";
import { getCurrentEnvironment } from "./utils/Environments";
import { utf8_decoder } from "./utils/Constants";
import { ServicesCryptofacil } from "./utils/ApiHelperCryptofacil";


const accountInfoImpl = async () => {
    const config = await Services.getSystemConfigs("CRYPTOFACIL").catch(() => toast.error("User / phone Invalid"));
    if (!config) return;
    return {
        cclw: config.values._web_code,
        apiKey: config.values._api_key,
        maxAmountZinli: config.values._amount_limit_zinli || "200"
    };
};

const loginImpl = async (login) => {
    const loginResult = await Services.login(login, {}).catch(() => toast.error("User / Password Invalid"));
    if (!loginResult || !loginResult.token) {
        return;
    }
    setSession(getCurrentEnvironment().apiKey + '|' + loginResult.token);

    const services = loginResult?.walletServices?.filter(service => service.name === 'RECHARGE') || [];
    if (services.length === 0) {
        toast.error("User / Password Invalid")
        console.error("Missing service")
        return;
    }

    const resultUser = loginResult?.user;
    const user = Builders.buildUser(
        resultUser.idUsr,
        resultUser.name,
        resultUser.lastname,
        resultUser.phone,
        resultUser.email,
        services[0]?.idUsrService);

    setUser(user);
    return loginResult;
};

export const apiGetBalanceImpl = async () => {
    let user = getUser();
    const { idUsr } = user;

    const { balance } = await Services.getUserBalance(idUsr).catch(() => toast.error("Error to get balance"));

    const { disponible } = balance[0];

    return disponible;
};

const buildWidgetUrlImpl = async (amount) => {
    try {
        let user = getUser();
        let description = "Recarga PF";

        let searchActivity = Builders.buildSearchActivity(amount, user.idUsrService, description);
        console.log("searchActivity", searchActivity);
        const searchActivityResult = await Services.searchActivity(cryptoUtil.encodeHex(searchActivity));
        console.log("searchActivityResult", searchActivityResult);
        if (!searchActivityResult || !searchActivityResult.sourceSearch) {
            return;
        }

        let activity = Builders.buildActivity(amount, searchActivityResult.sourceSearch, description, null, user.email, user.idUsr);
        console.log("activity", activity);
        const payActivityResult = await Services.payActivity(activity);
        console.log("payActivityResult", payActivityResult);
        if (!payActivityResult || !payActivityResult.idActivity) {
            return;
        }

        return getCurrentEnvironment().widgetUrl
            .replace('{session}', getSession())
            .replace('{idActivity}', payActivityResult.idActivity)
            .replace('{idUsrService}', user.idUsrService);
    } catch (error) {
        throw new Error(error);
    }
};

const getLanguageImpl = async (lang) => {
    const language = await Services.getLanguage(lang).catch(() => console.error("Error to translate"));
    if (!language || !language?.file) return;

    return language?.file;
};

const getValidateEmailZinliImpl = async (email, phone) => {
    const validation = await Services.getValidateEmailZinli({ email }).catch(() => toast.error("No encontrado"));
    if (!validation?.limit) return false;

    return validation?.limit;
};

const getReceiveDataImpl = async (codOper) => {
    const receiveData = await Services.getReceiveData(codOper).catch(() => console.error("Error to get receive data"));
    if (!receiveData || !receiveData?.receiptInfo || !receiveData?.receiptInfo[0]) return;

    const receipt = receiveData.receiptInfo[0];
    const txCtrl = receipt.txCtrl || {};

    const payment = {
        date: receipt.formatDate,
        name: txCtrl.completeName,
        authStatus: receipt.authStatus,
        type: receipt.type,
        messageSys: receipt.messageSys,
        codOper: receipt.codOper,
        status: receipt.status,
        totalPay: receipt.totalPay,
        email: receipt.email,
        txType: receipt.txType,
        expirationDate: receipt.expirationDate,
        concept: utf8_decoder(receipt.txCtrl.description),
        isBlock: !!receipt.isBlock,
        transactionId: receipt.idtx,
    };

    return payment
};

const createUserCryptofacil = async (userData) => {
    try {
        const createUserResult = await ServicesCryptofacil.signup(userData);
        console.log("createUserResult services", createUserResult)
        return createUserResult
    } catch (error) {
        throw new Error(error);
    }
}

const loginCryptofacil = async (email) => {
    try {
        const loginUserResult = await ServicesCryptofacil.login(email)
        console.log("loginUserResult services", loginUserResult)
        return loginUserResult
    } catch (error) {
        throw new Error(error);
    }
}

const loginConfirmationCodeCryptofacil = async (code, email) => {
    try {
        const confirmationCodeResult = await ServicesCryptofacil.loginConfirmationCode(code, email)
        console.log("confirmationCodeResult services", confirmationCodeResult)
        return confirmationCodeResult
    } catch (error) {
        throw new Error(error);
    }
}

const getCryptoSubAccountCryptofacil = async (platform) => {
    try {
        const subAccountData = await ServicesCryptofacil.getCryptoSubAccount(platform)
        console.log("subAccountData services", subAccountData)

        if (!subAccountData) return null

        return subAccountData?.account
    } catch (error) {
        if (String(error?.message || error).toLowerCase().includes("need load")) {
            return { needLoad: true };
        }
        throw error
    }
}

const setZinliData = async (data) => {
    try {
        const zinliData = await ServicesCryptofacil.setZinliDataAcc(data)
        console.log("zinliData seteada services", zinliData)
        return zinliData
    } catch (error) {
        throw error || "error to try to set zinli data"
    }
}

const getCryptoCoins = async (platform) => {
    try {
        const coinsData = await ServicesCryptofacil.getCryptoCoinsAsync(platform)
        console.log("coinsData services", coinsData)
        return coinsData.map(coin => ({ label: coin?.coin, value: coin?.coin }))
    } catch (error) {
        throw new Error(error);
    }
}

const getCryptoNetworks = async (platform, coin) => {
    try {
        const networksData = await ServicesCryptofacil.getCryptoNetworksAsync(platform, coin)
        console.log("networksData services", networksData)
        return networksData.map(network => ({ label: network?.name, value: network?.network }));
    } catch (error) {
        throw new Error(error);
    }
}

const getCryptoConversion = async (platform, coin, amount) => {
    try {
        const conversionData = await ServicesCryptofacil.getCryptoConversionAsync(platform, coin, amount)
        console.log("conversionData services", conversionData)

        if (!conversionData || !conversionData.conversion || !conversionData.coin) throw new Error("No se pudo obtener la conversión")

        return `${conversionData.conversion} ${conversionData.coin}`
    } catch (error) {
        throw new Error(error);
    }
}

const getCryptoAddress = async (platform, coin, network) => {
    try {
        const addressData = await ServicesCryptofacil.getCryptoAddressAsync(platform, coin, network)
        console.log("addressData services", addressData)

        if (!addressData || !addressData.address) throw new Error("No se pudo obtener la dirección del pago. Ponte en contacto con soporte.")

        return addressData.address
    } catch (error) {
        throw new Error(error);
    }
}

const getEstimateCost = async (platform, amount) => {
    try {
        const estimateData = await ServicesCryptofacil.getEstimateCostAsync(platform, amount)
        console.log("estimateData services", estimateData)

        if (!estimateData) throw new Error("No se pudo obtener la estimacion de costos. Ponte en contacto con soporte.")

        return estimateData
    } catch (error) {
        throw new Error(error);
    }
}

export const ManageService = {
    accountInfo: accountInfoImpl,
    login: loginImpl,
    buildWidgetUrl: buildWidgetUrlImpl,
    apiGetBalance: apiGetBalanceImpl,
    getLanguage: getLanguageImpl,
    getValidateEmailZinli: getValidateEmailZinliImpl,
    getReceiveData: getReceiveDataImpl,
    createUserCryptofacil,
    loginCryptofacil,
    loginConfirmationCodeCryptofacil,
    getCryptoSubAccountCryptofacil,
    setZinliData,
    getCryptoCoins,
    getCryptoNetworks,
    getCryptoConversion,
    getCryptoAddress,
    getEstimateCost
}
